<template>
  <div class="container-fluid">
    <h3 class="mb-4">{{client.name}}</h3>

    <ul class="nav nav-tabs">
      <li class="nav-item">
        <a :class="'nav-link ' + (view === 'calendar' ? 'active' : '')"
           href="#"
           @click="switchView('calendar')">
          Календарь
        </a>
      </li>
      <li class="nav-item">
        <a :class="'nav-link ' + (view === 'drugList' ? 'active' : '')"
           href="#"
           @click="switchView('drugList')">
          Назначения
        </a>
      </li>
      <li class="nav-item">
        <a :class="'nav-link ' + (view === 'drugs' ? 'active' : '')"
           href="#"
           @click="switchView('drugs')">
          Назначения (NEW)
        </a>
      </li>
      <li class="nav-item">
        <a :class="'nav-link ' + (view === 'healthStatus' ? 'active' : '')"
           href="#"
           @click="switchView('healthStatus')">
          Статус здоровья
        </a>
      </li>
      <li class="nav-item">
        <a :class="'nav-link ' + (view === 'conclusion' ? 'active' : '')"
           href="#"
           @click="switchView('conclusion')">
          Заключения
        </a>
      </li>
      <li class="nav-item">
        <a :class="'nav-link ' + (view === 'questionnaire' ? 'active' : '')"
           href="#"
           @click="switchView('questionnaire')">
          Анкеты
        </a>
      </li>
      <li class="nav-item">
        <a :class="'nav-link ' + (view === 'checkup' ? 'active' : '')"
           href="#"
           @click="switchView('checkup')">
          Метрики
        </a>
      </li>
      <li class="nav-item">
        <a :class="'nav-link ' + (view === 'test' ? 'active' : '')"
           href="#"
           @click="switchView('test')">
          Анализы
        </a>
      </li>
      <li class="nav-item">
        <a :class="'nav-link ' + (view === 'strategy' ? 'active' : '')"
           href="#"
           @click="switchView('strategy')">
          Стратегии
        </a>
      </li>
      <li class="nav-item">
        <a :class="'nav-link ' + (view === 'note' ? 'active' : '')"
           href="#"
           @click="switchView('note')">
          Заметки
        </a>
      </li>
      <li class="nav-item">
        <a :class="'nav-link ' + (view === 'drugSchedule' ? 'active' : '')"
           href="#"
           @click="switchView('drugSchedule')">
          График приема
        </a>
      </li>
      <li class="nav-item">
        <a :class="'nav-link ' + (view === 'shopList' ? 'active' : '')"
           href="#"
           @click="switchView('shopList')">
          Лист покупок
        </a>
      </li>
      <li class="nav-item">
        <a class="nav-link"
           :href=client.fileUrl
           target="_blank">
          Файлы
        </a>
      </li>
    </ul>

    <div v-if="view === 'drugList'">
      <ClientDrugForm
          :client="client"
          :drugPrescription="drugPrescription"
          v-on:return-to-list="setPrescription(null)"
          v-if="prescriptionId"/>
      <ClientDrugList
          :drugPrescriptions="drugPrescriptions"
          v-on:open-prescription-id="setPrescription"
          v-else/>
    </div>

    <div v-else-if="view === 'drugs'">
      <ClientDrug
          :client="client"
          :drugPrescription="drugPrescription" />
    </div>

    <div v-else-if="view === 'drugSchedule'">
      <ClientDrugSchedule :drugPrescriptions="drugPrescriptions" />
    </div>

    <div v-else-if="view === 'shopList'">
      <ClientDrugShopList :drugPrescriptions="drugPrescriptions" />
    </div>

    <div v-else-if="view === 'healthStatus'">
      <HealthStatus :client="client" />
    </div>

    <div v-else-if="view === 'questionnaire'">
      <Questionnaire
          :client="client"
          :questionnaires="questionnaires"
          :answers="answers" />
    </div>

    <Checkup
        v-else-if="view === 'checkup'"
        :client="client" />

    <Test
        v-else-if="view === 'test'"
        :client="client" />

    <Note
        v-else-if="view === 'note'"
        :client="client" />

    <Conclusion
        v-else-if="view === 'conclusion'"
        :client="client" />

    <Strategy
        v-else-if="view === 'strategy'"
        :client="client" />

    <Calendar v-else :drugPrescriptions="drugPrescriptions"/>
  </div>
</template>

<script>
  import Calendar from './Calendar';
  import Questionnaire from './Questionnaire';
  import ClientDrug from './Drug';
  import ClientDrugList from './drug/List';
  import ClientDrugForm from './drug/Form';
  import ClientDrugShopList from './drug/ShopList';
  import ClientDrugSchedule from './drug/Schedule';
  import HealthStatus from './Health';
  import Checkup from './Checkup';
  import Test from './Test';
  import Note from './Note';
  import Conclusion from './Conclusion';
  import Strategy from './Strategy';

  export default {
    name: 'ClientItem',

    components: {
      Calendar,
      ClientDrug,
      ClientDrugList,
      ClientDrugForm,
      ClientDrugShopList,
      ClientDrugSchedule,
      HealthStatus,
      Questionnaire,
      Checkup,
      Test,
      Note,
      Conclusion,
      Strategy,
    },

    props: ['client'],

    data() {
      return {
        view: 'calendar',
        prescriptionId: null,
      };
    },

    created() {
      this.$store.dispatch('LOAD_DRUG_PRESCRIPTIONS', this.client.id);
      this.$store.dispatch('LOAD_QUESTIONNAIRES');
      this.$store.dispatch('LOAD_QUESTIONNAIRE_ANSWERS', this.client.id);
    },

    computed: {
      drugPrescriptions() {
        return this.$store.getters.clientDrugPrescriptions(this.client.id);
      },

      drugPrescription() {
        return this.drugPrescriptions.find(item => item.id === this.prescriptionId);
      },

      questionnaires() {
        return this.$store.state.questionnaires;
      },

      answers() {
        return this.$store.getters.clientAnswers(this.client.id);
      },
    },

    methods: {
      setPrescription(id) {
        this.prescriptionId = id;
      },

      switchView(view) {
        this.setPrescription(null);

        this.view = view;
      },
    }
  };
</script>
